import { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

import { FiCheckCircle, FiXCircle, FiBox } from 'react-icons/fi';

const INTEGRATIONS = {
    xero: {
        name: 'Xero',
        accent: 'text-sky-700',
        bg: 'bg-sky-400/20',
        label: 'X',
    },
};

const IntegrationPopup = () => {
    const { company } = useAuth();
    const { integration } = useParams();
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const status = params.get('status');

    const isSuccess = status === 'success';
    const currentIntegration = INTEGRATIONS[integration] || {
        name: integration || 'Integration',
        accent: 'text-zinc-700',
        bg: 'bg-black/10',
        label: <FiBox />,
    };

    const companyInitial = useMemo(() => {
        return (
            company?.avatar_url ||
            company?.logo_url ||
            company?.name?.[0] ||
            company?.company_name?.[0] ||
            company?.slug?.[0] ||
            'N'
        );
    }, [company]);

    const companyName =
        company?.name ||
        company?.company_name ||
        company?.slug ||
        'Company';

    useEffect(() => {
        if (!window.opener) return;

        window.opener.postMessage(
            {
                type: 'INTEGRATION_CONNECTED',
                integration,
                status,
            },
            window.location.origin
        );

        setTimeout(() => {
            window.close();
        }, 4000);
    }, [integration, status]);

    return (
        <div className="mobile-public-page integration-page w-full h-full absolute top-0 left-0 bg-white rounded-lg flex items-center justify-center text-zinc-700 px-4">
            <div className="text-center max-w-md w-full">
                <div className="w-16 h-16 mx-auto rounded-2xl bg-zinc-700 text-zinc-100 flex items-center justify-center text-2xl font-black shadow-md overflow-hidden">
                    {company?.avatar_url || company?.logo_url ? (
                        <img
                            src={company.avatar_url || company.logo_url}
                            alt={companyName}
                            className="w-full h-full object-cover"
                        />
                    ) : (
                        String(companyInitial).charAt(0).toUpperCase()
                    )}
                </div>

                <h1 className="mt-4 text-xl font-black tracking-tight">
                    {companyName}
                </h1>

                <div className={`mt-6 mx-auto w-14 h-14 rounded-2xl ${currentIntegration.bg} ${currentIntegration.accent} flex items-center justify-center text-2xl font-black`}>
                    {currentIntegration.label}
                </div>

                <div className="mt-5 flex justify-center">
                    {isSuccess ? (
                        <FiCheckCircle className="text-green-600 text-5xl" />
                    ) : (
                        <FiXCircle className="text-red-600 text-5xl" />
                    )}
                </div>

                <p className="mt-4 text-sm font-semibold text-zinc-900">
                    {isSuccess
                        ? `${currentIntegration.name} connected successfully. This window will close automatically.`
                        : `${currentIntegration.name} connection failed. You can close this window and try again.`}
                </p>
            </div>
        </div>
    );
};

export default IntegrationPopup;